export const AccountType = ["Cheque", "Savings"];
export default AccountType;
